import(/* webpackMode: "eager" */ "/home/claude/hadatha/hadatha/src/app/music/page.tsx");
